import React, { useDebugValue, useEffect } from 'react';
import { Trans, Translation, useTranslation } from 'react-i18next';
import { images } from '../assets/images';
import Advantages from '../components/Advantages';
import ContactUs from '../components/ContactUs';
import CTA from '../components/CTA';
import LeftMoveInSection from '../components/LeftMoveInSection';
import RightMoveInSection from '../components/RightMoveInSection';
import UpMoveInSection from '../components/UpMoveInSection';
import MoveInSection from '../components/UpMoveInSection';
import useWindowDimensions from '../hooks/useWindowDimensions';
import './Industria40.css';

function Industria40() {
  const { t, i18n } = useTranslation();
  const { height, width } = useWindowDimensions();

  return (
    <div className="Industria40">
      <div className='Industria40_hero'>
        <div className='column-left'>
          <Trans>
          <h1 className='title'>{t('landing.title')}&nbsp;{t('landing.title2')}</h1>
          </Trans>
        <p className='align-left'>{t('landing.intro')}</p>
        </div>
        <div className='column-right'>
          {width < 1024?
        <img src={images.hero_bg}/>
          : null}
        </div>
      </div>
    {/* SECTION 1 */}
    <section className='intro'>
          {width > 1024?
        <div className='title'>
          <RightMoveInSection>
          <svg width="229" height="37" viewBox="0 0 229 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M227.768 20.2677C228.744 19.2914 228.744 17.7085 227.768 16.7322L211.858 0.822306C210.882 -0.154004 209.299 -0.154004 208.322 0.822306C207.346 1.79862 207.346 3.38153 208.322 4.35784L222.464 18.5L208.322 32.6421C207.346 33.6184 207.346 35.2013 208.322 36.1776C209.299 37.154 210.882 37.154 211.858 36.1776L227.768 20.2677ZM-9.42408e-05 21L226 21L226 16L-9.424e-05 16L-9.42408e-05 21Z" fill="#ffffff"/>
            <defs>
            </defs>
          </svg>
      </RightMoveInSection>
      <RightMoveInSection>
            <span className='align-left'>{t('landing.functionalities.intro')}</span>
      </RightMoveInSection>
        </div>
          :  
        <div className='title'>
            <span>{t('landing.functionalities.intro')}</span>
        </div>
        }
      <UpMoveInSection>
        <div className='wrapper-box-image-container'>
          <div className='box-image'>
            <div className='wrap-image'>
              <img id="imgs-3" src={images.telemetria}/>
            </div>
              <span>{t('landing.functionalities.1')}</span>
          </div>
          <div className='box-image'>
            <div className='wrap-image'>
              <img id="imgs-3" src={images.gestioneaccessi}/>
            </div>
              <span>{t('landing.functionalities.2')}</span>
          </div>
          <div className='box-image'>
            <div className='wrap-image'>
            <img id="imgs-3" src={images.alert}/>
            </div>
              <span>{t('landing.functionalities.3')}</span>
          </div>
          <div className='box-image'>
            <div className='wrap-image'>
              <img id="imgs-3" src={images.payment}/>
            </div>
              <span>{t('landing.functionalities.4')}</span>
          </div>
          <div className='box-image'>
          <div className='wrap-image'>
              <img id="imgs-3" src={images.cybersecurity}/>
            </div>
              <span>{t('landing.functionalities.5')}</span>
          </div>
          <div className='box-image'>
          <div className='wrap-image'>
              <img id="imgs-3" src={images.assettracking}/>
            </div>
              <span>{t('landing.functionalities.6')}</span>
          </div>
        </div>
      </UpMoveInSection>
    </section>
    <UpMoveInSection>
      <section className='dashboard'>
        <div className='text'>
          <h2>{t('landing.bi.title')}</h2>
          <p>{t('landing.bi.subtitle')}</p>
        </div>
          <div className='imgs'>
            <img id="imgs-1" src={images.deviceoverview}/>
            <img id="imgs-2" src={images.cashstatus}/>
          </div>
      </section>
    </UpMoveInSection>
    <UpMoveInSection>
        <section className={width < 1024? 'dashboard reverse' : 'dashboard'}>
          <div className='imgs'>
            <img id="imgs-3" src={images.case_isolated}/>
            <img id="imgs-4" src={images.board}/>
          </div>
          <div className='text'>
            <h2>{t('landing.engineering.title')}</h2>
            <p>{t('landing.engineering.subtitle')}</p>
          </div>
        </section>
    </UpMoveInSection>
      {/* <CTA
      title={t("landing.payment.title")}
      subtitle={t("landing.payment.subtitle")}
      button={t("landing.payment.button")}
      image={"../assets/industria-40-credito-imposta.jpg"}
      ></CTA> */}
      <UpMoveInSection>
        <CTA
        title={t("landing.incentives.title")}
        subtitle={t("landing.incentives.subtitle")}
        button={t("landing.incentives.button")}
        link={"landing.incentives.link"}
        image={"../assets/industria-40-credito-imposta.jpg"}
        ></CTA>
      </UpMoveInSection>
      <UpMoveInSection>
      <section className='centered mt10'>
        <h2>{t("landing.payment.title")}</h2>
        <p>{t("landing.payment.subtitle")}</p>
        {/* <img src={images.case}/> */}
        <div className='wrapper-box-image-container nobg'>
                <div className='box-image'>
                  <div className='wrap-image'>
                    <img id="imgs-3" src={images.coins}/>
                  </div>
                    <span>{t('landing.payment.1')}</span>
                </div>
                <div className='box-image'>
                <div className='wrap-image'>
                    <img id="imgs-3" src={images.banknotes}/>
                  </div>
                    <span>{t('landing.payment.2')}</span>
                </div>
                <div className='box-image'>
                <div className='wrap-image'>
                    <img id="imgs-3" src={images.credit_card}/>
                  </div>
                    <span>{t('landing.payment.3')}</span>
                </div>
                <div className='box-image'>
                <div className='wrap-image'>
                    <img id="imgs-3" src={images.mobile}/>
                  </div>
                    <span>{t('landing.payment.4')}</span>
                </div>
            </div>
      </section>
      </UpMoveInSection>
      <ContactUs
      title={t('landing.contacts.title')}
      subtitle={t('landing.contacts.subtitle')}
      button={t('landing.contacts.button')}
      ></ContactUs>
    </div>
  );
}

export default Industria40;
